import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { PersonFill } from 'react-bootstrap-icons'
import SelectFacilitator from '../../facilitators/selector'
import useViewport from '../../../hooks/use-viewport'

const Facilitator = ({
    value = '',
    onChange = () => {}
}) => {
    const { breakpoint, breakpoints } = useViewport()
    return (
        <Form.Group as={Row}>
            <Form.Label column  sm={12} md={1} lg={2} xl={6} style={{ paddingRight: '0px' }}>
                <PersonFill size={30} />  {breakpoint >= breakpoints.XL || breakpoint <= breakpoints.SM ? 'Facilitator' : ''}
            </Form.Label>
            <Col sm={12} md={11} lg={10} xl={6}>
                <SelectFacilitator value={value} onChange={onChange} />
            </Col>
        </Form.Group>
    )
}

export default Facilitator